import * as ReselectModule from "reselect";
import { IApplicationState } from "..";
import { IChangeDemandListState } from "./types";

export const selectChangeDemandList: ReselectModule.Selector<
  IApplicationState,
  IChangeDemandListState
> = (state) => state.changeDemandList;
